export class Coords {
    x: number = 0;
    y: number = 0;
    constructor(){}
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/context-menu/class/coords.ts